// Routes.js
const Routes = {
    home: {
        main: '/',
        basketDetails: '/basket-details/:id',
        basketwithdrawbalance: '/basket-details/:id/withdraw-fund',
        basketCreate: '/create-basket',
        basketUpdate: '/update-basket/:id',
    },
    parishes: {
        main: '/parishes',
        organizationDetails: '/parishes/organization-details/:companyId',
    },
    staff: {
        main: '/staff',
        details: '/staff/:username',
        add: '/staff/add',
    },
    account: {
        main: '/my-account',
        edit: '/my-account/edit',
        changePhoto: '/my-account/change-photo',
        changePassword: '/my-account/change-password',
    },
    community: {
        main: '/community',
        ParishonerDetails: '/community/parishoner-detail/:uuid',
        issueRefund: '/community/parishoner-detail/transaction-detail/issue-refund/:id',
    },
    wallet: {
        main: '/wallet',
        parishWallet: '/wallet/parish-wallet',
        withdrawToBank: '/wallet/parish-wallet/withdraw-to-bank',
        givingBasket: '/wallet/giving-basket',
        paymentBasket: '/wallet/payment-basket',
        invoiceDetails: '/wallet/invoice-details/:id',
    },
    announcements: {
        main: '/announcements',
        details: '/announcements/details/:id',
        new: '/announcements/new-announcements',
        edit: '/announcements/edit/:id',
        createGroup: '/announcements/create-group',
        groupDetails: '/announcements/group-details/:id',
    },
    sendinvoice: {
        main: '/send-invoice',
    },
    sendmoney: {
        main: '/send-money',
    },
    auth: {
        login: '/login',
        forgotPassword: '/auth/forgot-password',
        verifyPin: '/auth/verify-pin',
    },
    qr: {
        main: '/qr/view-qr',
    },
    user: {
        userDetail: `/user/:username`,
    },
    transaction: {
        main: `/transaction/:id`,
    },
};

export default Routes;
